import { Button, Divider, Select } from "antd";
import { SelectProps, SelectValue } from "antd/es/select";
import { BaseSelectRef } from "rc-select";
import { useRef } from "react";

const MultiSelectWithAll = <T extends SelectValue = SelectValue>(props: SelectProps<T>) => {
  const selectRef = useRef<BaseSelectRef | null>(null);

  const handleSelectAll = () => {
    const valuePropName = props.fieldNames?.value ?? "value";
    //@ts-ignore
    props.onChange?.(props.options?.map(options => options[valuePropName]));
    selectRef?.current?.focus();
    selectRef?.current?.blur();
  };

  const selectAllRenderer = (menu: React.ReactNode) => (
    <>
      {menu}
      <Divider style={{ margin: "8px" }} />
      <div style={{ backgroundColor: "lightgray", padding: "5px" }}>
        <Button shape="round" onClick={handleSelectAll}>
          Select All
        </Button>
      </div>
    </>
  );
  return (
    <Select<T> {...props} ref={selectRef} mode="multiple" dropdownRender={selectAllRenderer} />
  );
};

export default MultiSelectWithAll;
